export const ATTRIBUTE_KEYS = {
    shipmentLocation: "shipmentLocationInfo",
    client: "Client",
    createdOn: "CreatedOn",
    postDate: "PostDate",
    assetLinks: "AssetLinks",
};
